import Form from "react-bootstrap/Form";

function ColorPicker(props) {
  const { defaultColor, name } = props;

  const colorSelect = (e) => {
    props.onColorChange(e)
  };
  return (
    <>
      <Form.Control
        type="color"
        id="exampleColorInput"
        defaultValue={defaultColor}
        title="Choose your color"
        name={name}
        style={{
          padding: '5px',
          border:'none',
          background:'#d7dae3',
          maxWidth: '4rem',
          height: 'calc(1.5em + 0.75rem + 2px)'
        }}
        onChange={colorSelect}
      />
    </>
  );
}

export default ColorPicker;
